import { format } from "date-fns";
import { useState } from "react";
import {
  SubscriptionPlanSection,
  PaymentInformation,
  SubscriptionBillingHistory,
  CancelSubscriptionSection,
  CancelSubscriptionModal,
  CancelSoloPlanModal,
  AccountOwnerAccessRequiredModal,
} from "@/components/organisms";
import { useOperator } from "@/hooks";
import { useGetProviderSubscriptionsQuery, useCancelProviderSubscriptionMutation } from "@/redux/apis/subscription/subscriptionPlansApi";
import { addToast } from "@/utils";
import { getErrorMessages } from "@/helpers/reduxHelpers";

export const SubscriptionsTab = () => {
  const operator = useOperator();
  const [isCancelModalOpen, setIsCancelModalOpen] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(true);

  const { data: subscriptions } = useGetProviderSubscriptionsQuery({
    providerId: operator.id,
    status: ["active", "pending_cancellation", "trial"],
    limit: 1,
    orderBy: ["startDate:DESC"],
  });

  const [cancelSubscription, { isLoading: isCancelling }] = useCancelProviderSubscriptionMutation();

  const isOwnerOrFa = operator.roles.includes("Owner") || operator.roles.includes("Fa_Access");
  if (!isOwnerOrFa) return <AccountOwnerAccessRequiredModal open={isModalOpen} onClose={() => setIsModalOpen(false)} />;

  const activeSubscription = subscriptions?.[0];
  const subscriptionEndDate = activeSubscription?.billingCycleEnd
    ? format(new Date(activeSubscription.billingCycleEnd), "MMMM d, yyyy")
    : "";

  // Check if the current subscription is a Solo plan
  const isSoloPlan = activeSubscription?.subscription?.name?.toLowerCase().includes("solo");

  const handleCancel = async () => {
    if (!activeSubscription) {
      addToast("danger", "No active subscription found");
      return;
    }

    try {
      await cancelSubscription({
        providerId: operator.id,
        subscriptionAssignmentId: activeSubscription.subscriptionAssignmentId,
      }).unwrap();

      addToast("success", "Subscription cancelled successfully");
      setIsCancelModalOpen(false);
      window.location.reload();
    } catch (error) {
      getErrorMessages(error as Parameters<typeof getErrorMessages>[0]).forEach((m) => addToast("danger", m));
    }
  };

  return (
    <div className="flex w-full flex-1 flex-col gap-4 py-4">
      <SubscriptionPlanSection />
      <PaymentInformation />
      <SubscriptionBillingHistory />
      <CancelSubscriptionSection onCancelClick={() => setIsCancelModalOpen(true)} />
      {isSoloPlan ? (
        <CancelSoloPlanModal
          open={isCancelModalOpen}
          onClose={() => setIsCancelModalOpen(false)}
          onCancel={handleCancel}
          isCancelling={isCancelling}
        />
      ) : (
        <CancelSubscriptionModal
          open={isCancelModalOpen}
          onClose={() => setIsCancelModalOpen(false)}
          subscriptionEndDate={subscriptionEndDate}
          onCancel={handleCancel}
          isCancelling={isCancelling}
        />
      )}
    </div>
  );
};
